<template>
  <div v-if="loading_page"></div>
  <div v-else id="invoice-POS">
    <div class="new-page">
      <!-- {{ data_other }} -->
      <center>
        <!-- <div id="wb_Image1" style="position: absolute; left: 0px; top: 0px; width: 1029px; height: 1455px; z-index: 1; background-color: aqua;"> -->
        <div id="wb_Image1" style="position: absolute; left: 15px; top: -138px; width: 1029px; height: 1455px; z-index: 1">
          <!-- <div id="wb_Image1" style="position: absolute; left: 0px; top: 0px; width: 1029px; height: 1475px; z-index: 1"> -->
          <!-- <img :src="img_bg2" id="Image1" alt="" width="1029" height="1474" /> -->
        </div>
        <input type="text" style="position: absolute; left: 700px; top: 28px; width: 30px; height: 20px; z-index: 2" :value="num_page" disabled />
        <input type="text" style="position: absolute; left: 850px; top: 28px; width: 30px; height: 20px; z-index: 3" :value="num_all_page" disabled />
        
        <input type="text" :style="`position: absolute; left: ${530 + 10}px; top: 145px; width: 18px; height: 28px; z-index: 4`" :value="store_personal_id[0]" disabled />
        <input type="text" :style="`position: absolute; left: ${560 + 10}px; top: 145px; width: 18px; height: 28px; z-index: 5`" :value="store_personal_id[1]" disabled />
        <input type="text" :style="`position: absolute; left: ${588 + 10}px; top: 145px; width: 18px; height: 28px; z-index: 6`" :value="store_personal_id[2]" disabled />
        <input type="text" :style="`position: absolute; left: ${616 + 15}px; top: 145px; width: 18px; height: 28px; z-index: 7`" :value="store_personal_id[3]" disabled />
        <input type="text" :style="`position: absolute; left: ${645 + 15}px; top: 145px; width: 18px; height: 28px; z-index: 11`" :value="store_personal_id[4]" disabled />
        <input type="text" :style="`position: absolute; left: ${675 + 15}px; top: 145px; width: 18px; height: 28px; z-index: 10`" :value="store_personal_id[5]" disabled />
        <input type="text" :style="`position: absolute; left: ${705 + 15}px; top: 145px; width: 18px; height: 28px; z-index: 9`" :value="store_personal_id[6]" disabled />
        <input type="text" :style="`position: absolute; left: ${735 + 15}px; top: 145px; width: 18px; height: 28px; z-index: 8`" :value="store_personal_id[7]" disabled />
        <input type="text" :style="`position: absolute; left: ${766 + 15}px; top: 145px; width: 18px; height: 28px; z-index: 16`" :value="store_personal_id[8]" disabled />
        <input type="text" :style="`position: absolute; left: ${796 + 15}px; top: 145px; width: 18px; height: 28px; z-index: 15`" :value="store_personal_id[9]" disabled />
        <input type="text" :style="`position: absolute; left: ${826 + 15}px; top: 145px; width: 18px; height: 28px; z-index: 14`" :value="store_personal_id[10]" disabled />
        <input type="text" :style="`position: absolute; left: ${856 + 15}px; top: 145px; width: 18px; height: 28px; z-index: 13`" :value="store_personal_id[11]" disabled />
        <input type="text" :style="`position: absolute; left: ${886 + 15}px; top: 145px; width: 18px; height: 28px; z-index: 12`" :value="store_personal_id[12]" disabled />

        <input type="text" :style="`position: absolute; left: ${765 + 15}px; top: 200px; width: 18px; height: 28px; z-index: 21`" :value="store_code[0]" disabled />
        <input type="text" :style="`position: absolute; left: ${795 + 15}px; top: 200px; width: 18px; height: 28px; z-index: 20`" :value="store_code[1]" disabled />
        <input type="text" :style="`position: absolute; left: ${825 + 15}px; top: 200px; width: 18px; height: 28px; z-index: 19`" :value="store_code[2]" disabled />
        <input type="text" :style="`position: absolute; left: ${855 + 15}px; top: 200px; width: 18px; height: 28px; z-index: 18`" :value="store_code[3]" disabled />
        <input type="text" :style="`position: absolute; left: ${885 + 15}px; top: 200px; width: 18px; height: 28px; z-index: 17`" :value="store_code[4]" disabled />

        <div v-for="(item, i) in data_other.product_list" :key="i">
          <input type="text" :style="`position: absolute; left: 135px; top: ${380 + list_top[i]}px; width: 47px; height: 28px; z-index: 22;`" :value="item.no" disabled />
          <input type="text" :style="`position: absolute; left: 212px; top: ${380 + list_top[i]}px; width: 131px; height: 28px; z-index: 23;`" :value="invoice_code" disabled />
          <input type="text" :style="`position: absolute; left: 380px; top: ${380 + list_top[i]}px; width: 292px; height: 28px; z-index: 24;`" :value="item.product_name" disabled />
          <input type="text" :style="`position: absolute; left: 710px; top: ${380 + list_top[i]}px; width: 47px; height: 28px; z-index: 25;`" :value="item.qty" disabled />
          <input type="text" :style="`position: absolute; left: 788px; top: ${380 + list_top[i]}px; width: 123px; height: 28px; z-index: 26; text-align: end;`" :value="formatPrice(item.total)" disabled />
          <!-- <input type="text" :style="`position: absolute; left: 885px; top: ${380 + list_top[i]}px; width: 30px; height: 28px; z-index: 27;`" value=".23" disabled /> -->
        </div>

        <input type="text" style="position: absolute; left: 788px; top: 1042px; width: 123px; height: 28px; z-index: 28; text-align: end" :value="formatPrice(data_other.total)" disabled />
        <!-- <input type="text" style="position: absolute; left: 885px; top: 1042px; width: 30px; height: 28px; z-index: 29" value=".22" disabled /> -->

        <input
          type="text"
          style="position: absolute; left: 468px; top: 1175px; width: 180px; height: 28px; z-index: 30"
          :value="new Date().getDate() + '/' + parseInt(new Date().getMonth()) + 1 + '/' + (parseInt(new Date().getFullYear()) + 543)"
          disabled
        />
      </center>
    </div>
  </div>
  <!--End Invoice-->
</template>

<script>

import img_bg2 from "@/assets/arin_assets/S__70344728.jpg";

// import img_arin from "@/assets/arin_assets/pharmacare-black.png";
// import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";
export default {
  props: {
    store_personal_id: String,
    store_code: String,
    invoice_code: String,
    data_other: {},
    num_page: Number,
    num_all_page: Number,
  },
  data() {
    return {
      loading_page: false,
      img_bg2: img_bg2,
      list_top: [0, 42, 85, 130, 170, 210, 250, 290, 330, 370, 410, 450, 495, 535, 577, 618],
    };
  },
  methods: {
    formatPrice,
    
  },
  async mounted() { },
};
</script>

<style scoped>
#wb_Image1 {
  vertical-align: top;
}
#Image1 {
  border: 0px solid #000000;
  border-radius: 0px;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

input,
textarea {
  line-height: 17px;
  margin: 0;
  /* border: 1px solid #dee2e6; */
  border-radius: 4px;
  /* background-color: #ffffff; */
  background-image: none;
  color: #212529;
  font-family: Arial;
  font-weight: normal;
  font-style: normal;
  font-size: 13px;
  text-align: left;
  padding: 4px 4px 4px 4px;
  resize: none;
}

input:focus {
  /* border-color: #66afe9; */
  /* box-shadow: inset 0px 1px 1px rgba(0, 0, 0, 0.075), 0px 0px 8px rgba(102, 175, 233, 0.6); */
  outline: 0;
}
</style>
